import { render, staticRenderFns } from "./EditErp.vue?vue&type=template&id=36444f34"
import script from "./EditErp.vue?vue&type=script&lang=js"
export * from "./EditErp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports